export default function($) {
  
  var h_calendar_form = $('#js-h-calendar-search')

  if (h_calendar_form.length > 0) {

    $(".js-h-calendar-ean-parts").keyup(function(e) {
      // checkout https://keycode.info/ for keycodes
      if (e.keyCode == 8) { // backspace
        $(this).prev('.js-h-calendar-ean-parts').select();
      } else if($.isNumeric($(this).val())) {
        $(this).next('.js-h-calendar-ean-parts').select();
      }
    });
    
    h_calendar_form.submit(function(event) {
      event.preventDefault()
      
      var ajaxUrl = $(this).data('ajaxurl')
      var action = $(this).data('action')

      if ($('.js-h-calendar-ean').is(':visible')) {
        var ean = $('.js-h-calendar-ean').val()
      } else {
        var ean = jQuery.map($(".js-h-calendar-ean-parts"), function(ean_part) {
          return $(ean_part).val()
        }).join( "" )  
      }
      
      $.ajax({
        type: "POST",
        url: ajaxUrl,
        data: {
          'action': action,
          'ean': ean,
        },
        success: function(response){
          // @todo: END SPINER

          var response_data = JSON.parse(response)

          $('.js-h-calendar-error').empty()
          $('.js-h-calendar-results').empty()

          var error = response_data.error
          if (error.length > 0) {
            $('.js-h-calendar-error').text(error)
            return;
          }

          var pdf_filepath = response_data.pdf_filepath

          var win = window.open(pdf_filepath, '_blank');
          
          if (win) {
            //Browser has allowed it to be opened
            win.focus();
          } else {
            $('.js-h-calendar-error').text("Merci d'autoriser les popups pour nous permettre d'afficher votre agenda")
          }
        },
      });

    })
  }
  
}
